/*
 * This unpublished material is proprietary to Vaticle.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of Vaticle.
 */

import { MFAPolicy, mfaPolicyOf } from "./team";
import {
    TeamCtlProtoGetTeamSecurityRecommendationsRes,
} from "../../application/protocol/team-controller";


export interface SecurityRecommendations {
    addSecurityContact?: AddSecurityContact;
    reduceAdminCount?: ReduceAdminCount;
    increaseMFAPolicy?: IncreaseMFAPolicy;
    enableMFA?: EnableMFA;
    setBackups?: SetBackups;
}

interface AddSecurityContact {}

interface ReduceAdminCount {
    adminCount: number;
}

interface IncreaseMFAPolicy {
    mfaPolicy: MFAPolicy;
}

interface EnableMFA {
    missingMFAEmails: string[];
}

interface SetBackups {
    missingBackups: string[];
}

export function securityRecommendationsOf(data: TeamCtlProtoGetTeamSecurityRecommendationsRes): SecurityRecommendations {
    return {
        addSecurityContact: data.hasAddSecurityContact ? {} : undefined,
        reduceAdminCount: data.hasReduceAdminCount ? { adminCount: data.reduceAdminCount.adminCount } : undefined,
        increaseMFAPolicy: data.hasIncreaseMfaPolicy ? { mfaPolicy: mfaPolicyOf(data.increaseMfaPolicy.mfaPolicy) } : undefined,
        enableMFA: data.hasEnableMfa ? { missingMFAEmails: data.enableMfa.missingMfaEmails } : undefined,
        setBackups: data.hasSetBackups ? { missingBackups: data.setBackups.missingBackups } : undefined,
    }
}
